import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { Formik, Field, Form } from "formik";
import authService from "../../services/auth.service";
import ToastComponent from "../Common/TaostComponent";
const ResetPassword = (props) => {
  let params = useParams(); // calling the hook
  const verificationLink = params.verificationLink;

  const navigate = useNavigate();
  useEffect(() => {
    authService.resetPassword(verificationLink).then((res) => {
      if (res.status !== 200) {
        ToastComponent(res.message, "error");
      }
    });
  }, [verificationLink, navigate]);

  const initialValues = {
    confirm_password: "",
    password: "",
  };
  const validationSchema = Yup.object({
    password: Yup.string()
      .required("Password is required.")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Password must have a mimimum of 8 characters and must be a combination of numeric, alphabet and special characters."
      ),
    confirm_password: Yup.string()
      .required("Confirm Password is required.")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });
  const onSubmit = (formValue) => {
    formValue.validate_string = verificationLink;
    authService.saveResetPassword(formValue).then((res) => {
      if (res.status !== 200) {
        ToastComponent(res.message, "error");
      } else {
        ToastComponent(res.message, "success");
        navigate("/login");
      }
    });
  };
  return (
    <div className="middle-section">
      <div className="container">
        <div className="cms-section">
          <div className="heading">
            <h2>Reset Password</h2>
          </div>
          <div className="whitebox">
            <div className="playerprofile-section">
              <div className="loginform">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {({
                    errors,
                    handleChange,
                    values,
                    touched,
                    setFieldValue,
                  }) => (
                    <Form>
                      <div className="form-group">
                        <Field
                          name="password"
                          type="password"
                          className="form-control"
                          placeholder="Password*"
                        />
                        *Must be a minimum of 8 characters, contain at least a
                        number, an uppercase & lowercase alphabet and a special
                        character (ex: Hello@123).
                        {touched.password && errors.password && (
                          <span className="help-inline error">
                            {errors.password}
                          </span>
                        )}
                      </div>
                      <div className="form-group mb-3">
                        <Field
                          name="confirm_password"
                          type="password"
                          className="form-control"
                          placeholder="Confirm Password*"
                        />
                        {touched.confirm_password &&
                          errors.confirm_password && (
                            <span className="help-inline error">
                              {errors.confirm_password}
                            </span>
                          )}
                      </div>
                      <div className="text-center">
                        <button type="submit" className="btn btn-primary">
                          Reset Password
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
